const moment = require('moment');
const Q = require('q');
const _ = require('underscore');

const stringUtilities = require('utilities/stringUtilities');
const model = require('model/model');

const classService = require('services/classService');
const classUtilities = require('utilities/classUtilities');
const fetchRoster = classUtilities.fetchRoster;

const libraryService = require('services/libraryService');
const logger = require('utilities/logger');

const READING_TAB = 'reading';
const PASSAGES_TAB = 'passages';
const VOCAB_TAB = 'vocab';
const PAIREDTEXT_TAB = 'pairedText';
const AAD_TAB = 'articleADay';
const INDIVIDUAL_STUDENT_PROGRESS = 'individualStudentProgress';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const bookOfKnowledgeFormatter = (val, record, column) => {
	let cell = val;

	if (val > 0) {
		cell = '<div class="link-cell" title="View Big Book of Knowledge" aria-label="View Big Book of Knowledge">' + val + '</div>';
	}

	return String(cell);
};
const libraryFormatter = function (val, record, column) {
	let cell = val;
	let wordCount = record[column.field + 'Words'];
	let wordCountStr = ' (0 Words)';
	if (typeof wordCount === 'number') {
		wordCountStr = ' (' + stringUtilities.formatNumber(wordCount) + ' Words)';
	}

	cell = val + wordCountStr;

	if (val > 0) {
		cell = '<div class="link-cell" title="View Library Activity" aria-label="View Library Activity">' + cell + '</div>';
	}
	return String(cell);
};
const readingFormatter = function (val, record, column) {
	let wordCount = record[column.field + 'Words'];
	let wordCountStr = '';
	if (typeof wordCount === 'number') {
		wordCountStr = ' (' + stringUtilities.formatNumber(wordCount) + ' Words)';
	}
	return record[column.field] + wordCountStr;
};
const studentFormatter = function (val, record, column) {
	const firstName = stringUtilities.stripHTML(record.firstName);
	const lastName = record.lastName ? stringUtilities.stripHTML(record.lastName) : null;
	let name = firstName;
	if (lastName) {
		name += ' ' + lastName;
	}
	return (
		'<div class="link-cell"><span class="student-name" title="View Individual Student Progress" aria-label="View Individual Student Progress">' +
		name +
		'</span></div>'
	);
};

const numberFormatter = function (val, record, column) {
	return stringUtilities.formatNumber(val);
};

const startDateFormatter = function (val, record, col) {
	let startDate = '';
	if (record.startDate) {
		startDate = moment(record.startDate * 1000).format('MMM D');
	}
	return startDate;
};

const titleFormatter = function (val, record, col) {
	let classes = 'product-title';
	let hasWorkspace = record.hasWorkspace;

	if (hasWorkspace) {
		classes += ' has-workspace';
	}

	let title = '<span class="' + classes + '">' + val + '</span>';
	if (record.productType === 'AAD') {
		title += '<br />Article-A-Day';
	} else if (record.productType === 'P') {
		if (record.subType === 8001) {
			title += '<br />Spanish-English Paired Text';
		} else {
			title += '<br />Paired Text';
		}
	} else if (record.textSet && record.textSet.subType === 7000) {
		title += '<br />Book Study';
	}
	return '<div class="link-cell">' + title + '</div>';
};

const studentActivityFormatter = function (val, record, col) {
	let displayResult = '';
	if (record.productType !== 'AAD') {
		if (record.questionSets && record.questionSets.length) {
			displayResult = record.questionSets.reduce((title, item, idx) => {
				if (idx !== 0) {
					title += '<div class="qset-separator"></div>';
				}
				return (title += item.title.replace(': ', ':<br/>').replace('Questions', ''));
			}, displayResult);
		} else {
			displayResult = '<i>No question sets were assigned</i>';
		}
		return displayResult;
	}

	const bokAssigned = record.bokAssigned;
	const bokEntries = record.bokEntries;
	const bokWordsWritten = record.bokWordsWritten;
	const articlesRead = record.articlesRead;
	const articleWords = record.articleWords;
	const wordsExplored = record.wordsExplored;

	displayResult += articlesRead + ' Passages';
	displayResult += ' (' + articleWords + ' Words)';

	if (bokAssigned) {
		displayResult += '<br />' + bokEntries + ' B of K entries';
	}

	displayResult += ' (' + bokWordsWritten + ' Words)';

	if (wordsExplored !== null) {
		displayResult += '<br />' + wordsExplored + ' Words Explored';
	}

	return displayResult;
};

const correctFormatter = function (val, record, col) {
	let displayResult = '';
	if (record.productType !== 'AAD') {
		if (record.questionSets && record.questionSets.length) {
			displayResult = record.questionSets.reduce((title, item, idx) => {
				if (idx !== 0) {
					title += '<div class="qset-separator"></div>';
				}
				let br = item.title.indexOf('Vocab') !== -1 ? '<br/>&nbsp;' : '';
				if (item.graded) {
					return (title += item.correct + ' / ' + item.graded + br);
				} else {
					return (title += '&nbsp;' + br);
				}
			}, displayResult);
		}
		return displayResult;
	}
	return displayResult;
};

const submittedFormatter = function (val, record, col) {
	return record.submitted + ' / ' + record.assigned;
};

const classCorrectFormatter = function (val, record, col) {
	if (record.graded) {
		return record.correct + ' / ' + record.graded;
	} else {
		return '&nbsp;';
	}
};

const getPercentage = function (correct, graded) {
	let percentage = Math.round(parseFloat(correct / graded) * 100);
	if (isNaN(percentage)) {
		percentage = 0;
	}
	return percentage;
};

const classPercentageFormatter = function (val, record, col) {
	if (record.graded) {
		return getPercentage(record.correct, record.graded) + '%';
	} else {
		return '&nbsp;';
	}
};

const percentageFormatter = function (val, record, col) {
	let displayResult = '';
	if (record.productType !== 'AAD') {
		if (record.questionSets && record.questionSets.length) {
			displayResult = record.questionSets.reduce((title, item, idx) => {
				let percentage = getPercentage(item.correct, item.graded);
				if (idx !== 0) {
					title += '<div class="qset-separator"></div>';
				}
				let br = item.title.indexOf('Vocab') !== -1 ? '<br/>&nbsp;' : '';
				if (item.graded) {
					return (title += percentage + '%' + br);
				} else {
					return (title += '&nbsp;' + br);
				}
			}, displayResult);
		}
		return displayResult;
	}
	return displayResult;
};

const getCurrentMonth = function () {
	return new Date().getMonth();
};

const getMonthList = function (createdConstraint = 0) {
	let monthList = [];
	let selectValues = [];
	let created = moment(createdConstraint);
	let currentMonth = getCurrentMonth();

	monthList = months.map((m, idx) => {
		return {
			text: m,
			value: idx
		};
	});
	monthList = monthList.reverse();

	selectValues = monthList.slice(11 - currentMonth);
	selectValues = selectValues.concat(monthList.slice(0, 11 - currentMonth));

	// If the class is newer than 10 months,
	// we need to clip at least one month from the list
	if (created.isAfter(moment().subtract(10, 'months'))) {
		let createdMonth = created.get('month');

		// Slice works with negative indices, in the case currentMonth < createdMonth
		//  (class created last calendar year)
		selectValues = selectValues.slice(0, currentMonth - createdMonth + 1);
	}

	return selectValues;
};

const fetchStudentProgressResults = function (classCode, startDate, endDate) {
	if (!classCode || !startDate || !endDate) {
		return Q(false);
	}

	return Q.all([
		fetchRoster(classCode),
		classService.getClassSummaryByAssignment({
			cc: classCode,
			d: startDate,
			ed: endDate
		}),
		libraryService.getResultsByClass({
			cc: classCode,
			d: startDate,
			ed: endDate
		})
	])
		.spread(function (roster, results, libraryResults) {
			let persistedResults = model.get('studentProgressResults') || {};
			persistedResults = _.assign({}, persistedResults, {
				[classCode + startDate + endDate]: results
			});
			model.set('studentProgressResults', persistedResults);

			if (libraryResults && libraryResults.length) {
				let libraryResultsMap = {};
				libraryResultsMap = libraryResults.reduce((acc, r) => {
					let uid = r.uid;
					if (uid && acc[uid]) {
						acc[uid].push(r);
					} else if (uid) {
						acc[uid] = [r];
					}
					return acc;
				}, {});

				let persistedLibraryResults = model.get('studentProgressLibraryResults') || {};
				persistedLibraryResults = _.assign({}, persistedResults, {
					[classCode + startDate + endDate]: libraryResultsMap
				});
				model.set('studentProgressLibraryResults', persistedLibraryResults);
			}

			return true;
		})
		.fail(msg => {
			logger.error(msg);
			return false;
		});
};

const getStartDate = function (month) {
	let monthNumber = parseInt(month);
	let startDate = null;
	let year = new Date().getFullYear();
	let currentMonth = getCurrentMonth();

	if (month !== 'all' && isNaN(monthNumber)) {
		month = currentMonth;
		monthNumber = currentMonth;
	}
	if (month !== 'all' && monthNumber > currentMonth) {
		year -= 1;
	}

	if (month === 'all') {
		startDate = moment().subtract(1, 'year').add(1, 'month').startOf('month').toDate().getTime();
	} else {
		let startOfMonth = moment([year, month]);
		startDate = startOfMonth.toDate().getTime();
	}
	return startDate;
};

const getEndDate = function (month) {
	let startDate = getStartDate(month);
	let startOfMonth = null;
	let currentMonth = getCurrentMonth();

	if (month === 'all') {
		startOfMonth = moment([new Date().getFullYear(), currentMonth]);
	} else {
		startOfMonth = moment(startDate);
	}

	return moment(startOfMonth).endOf('month').toDate().getTime();
};

module.exports = {
	getCurrentMonth,
	getStartDate,
	getEndDate,
	gridKeys: {
		READING_TAB,
		PASSAGES_TAB,
		VOCAB_TAB,
		PAIREDTEXT_TAB,
		AAD_TAB,
		INDIVIDUAL_STUDENT_PROGRESS
	},
	QUESTION_TAB_TO_SET_NAME: {
		[PASSAGES_TAB]: [
			'Comprehension Questions',
			'Author’s Purpose Questions',
			'Character Questions',
			'Classify & Categorize Questions',
			'Inferencing/Drawing Conclusions Questions',
			'Inference Questions',
			'Explicit Information Questions',
			'Fact & Opinion Questions',
			'Figurative Language Questions',
			'Genre Questions',
			'Main Idea Questions',
			'Plot Questions',
			'Predicting Questions',
			'Setting Questions',
			'Theme Questions',
			'Vocabulary in Context Questions',
			'Voice Questions',
			'Cause & Effect Questions',
			'Compare & Contrast Questions',
			'Sequence Questions'
		],
		[VOCAB_TAB]: [/^Vocab:/, /^Vocabulary:/, /^Vocabulary Activity:/],
		[PAIREDTEXT_TAB]: 'Paired Text Questions'
	},
	grids: {
		[READING_TAB]: {
			title: 'Overall Reading',
			columns: [
				{
					text: 'Students',
					field: 'name',
					formatter: studentFormatter,
					textAlign: 'left',
					onClick: true
				},
				{
					text: 'Nonfiction<br />Passages Read',
					field: 'nonfiction',
					formatter: readingFormatter
				},
				{
					text: 'Literary<br />Passages Read',
					field: 'literary',
					formatter: readingFormatter
				},
				{
					text: 'Library<br />Passages Read',
					field: 'library',
					formatter: libraryFormatter
				},
				{
					text: 'Total<br />Passages Read',
					field: 'total',
					formatter: readingFormatter
				}
			]
		},
		[PASSAGES_TAB]: {
			title: 'Reading Passages',
			columns: [
				{
					text: 'Students',
					field: 'name',
					formatter: studentFormatter,
					textAlign: 'left',
					onClick: true
				},
				{
					text: 'Question Sets<br />Submitted',
					field: 'submitted',
					formatter: submittedFormatter
				},
				{
					text: 'Correct / Graded',
					field: 'correct',
					formatter: classCorrectFormatter
				},
				{
					text: '% Correct',
					field: 'percentage',
					formatter: classPercentageFormatter
				}
			]
		},
		// [VOCAB_TAB]: {
		// 	'title': 'Vocab Activities',
		// 	'columns': [{
		// 		'text': 'Students',
		// 		'field': 'name',
		// 'formatter': studentFormatter,
		// 'textAlign': 'left',
		// 'onClick': true
		// 	}, {
		// 		'text': 'Activities<br />Submitted',
		// 		'field': 'submitted',
		// 		'formatter': submittedFormatter
		// 	}, {
		// 		'text': 'Correct / Graded',
		// 		'field': 'correct',
		// 		'formatter': classCorrectFormatter
		// 	}, {
		// 		'text': '% Correct',
		// 		'field': 'percentage',
		// 		'formatter': classPercentageFormatter
		// 	}]
		// },
		[PAIREDTEXT_TAB]: {
			title: 'Paired Text',
			columns: [
				{
					text: 'Students',
					field: 'name',
					formatter: studentFormatter,
					textAlign: 'left',
					onClick: true
				},
				{
					text: 'Question Sets<br />Submitted',
					field: 'submitted',
					formatter: submittedFormatter
				},
				{
					text: 'Correct / Graded',
					field: 'correct',
					formatter: classCorrectFormatter
				},
				{
					text: '% Correct',
					field: 'percentage',
					formatter: classPercentageFormatter
				}
			]
		},
		[AAD_TAB]: {
			title: 'Article-A-Day',
			columns: [
				{
					text: 'Students',
					field: 'name',
					formatter: studentFormatter,
					textAlign: 'left',
					onClick: true
				},
				{
					text: 'Passages Read',
					field: 'articleCount',
					formatter: numberFormatter
				},
				{
					text: 'Words Read',
					field: 'wordCount',
					formatter: numberFormatter
				},
				{
					text: 'Book of Knowledge<br />Entries Submitted',
					field: 'bokCount',
					formatter: bookOfKnowledgeFormatter
				},
				{
					text: 'Words Written',
					field: 'wordsWritten',
					formatter: numberFormatter
				},
				{
					text: 'Words Explored',
					field: 'wordsExplored',
					formatter: numberFormatter
				}
			]
		},
		[INDIVIDUAL_STUDENT_PROGRESS]: {
			columns: [
				{
					text: 'Start Date',
					field: 'startDate',
					formatter: startDateFormatter,
					textAlign: 'left',
					flex: 1.5
				},
				{
					text: 'Status',
					field: 'status'
				},
				{
					text: 'Assignment',
					field: 'title',
					formatter: titleFormatter,
					flex: 2
				},
				{
					text: 'Question Set',
					field: 'studentActivity',
					formatter: studentActivityFormatter,
					flex: 1.2
				},
				{
					text: 'Correct / Graded',
					field: 'correct',
					formatter: correctFormatter
				},
				{
					text: '% Correct',
					field: 'percentage',
					formatter: percentageFormatter
				}
			]
		}
	},
	getMonthList,
	fetchStudentProgressResults,
	fetchRoster,
	getPercentage,
	months
};
